export const INVOICING: string = 'invoicing';
export const INVOICING_DASHBOARD: string = 'dashboard';
export const INVOICING_TASKS: string = 'tasks';
export const INVOICING_INVOICES: string = 'invoices';
export const INVOICING_TASK_DETAILS: string = 'details';
export const INVOICING_INVOICE_DETAILS: string = 'details';
